export enum StepperType {
  Tender = 'TENDER_STEPPER',
  Bid = 'BID_STEPPER',
  MultipleBid = 'MULTIPLE_BID_STEPPER',
}
